import React, { useMemo } from 'react';
import Row from '../shared/table/Row';
import SelectableRow from '../shared/table/SelectableRow';
import Table from '../shared/table/Table';

const ClientVehiclesTable = ({ vehicles, onVehicleClick }) => {
  const tableRows = useMemo(
    () =>
      vehicles.map((vehicle, i) => (
        <SelectableRow key={i} onClick={() => onVehicleClick(vehicle.vin)}>
          <Row
            children={
              <div>
                {vehicle.brand} {vehicle.model}
              </div>
            }
          />
          <Row children={vehicle.vin} />
          <Row children={vehicle.number || 'Не вказано'} />
        </SelectableRow>
      )),
    [vehicles, onVehicleClick],
  );

  return <Table columns={columns} data={tableRows} onRowClick={() => ({})} />;
};

const columns = [{ name: 'Марка' }, { name: 'VIN' }, { name: 'Номер' }];

export default ClientVehiclesTable;
